import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from 'components/ui/use-toast';
import { saveVocabWord } from './api';

/**
 * Saves a word picked in a passage (free for every learner) and says so. No query cache here: the exam
 * runner renders outside one in tests, and the word list refetches whenever it opens.
 */
export function useSaveWord() {
  const { t } = useTranslation();
  const { toast } = useToast();
  return useCallback(
    async (word: string, context: string) => {
      try {
        const saved = await saveVocabWord(word, context);
        toast({ title: t('vocab.saved', { word: saved.word }), variant: 'success' });
      } catch {
        toast({ title: t('vocab.save_failed'), variant: 'destructive' });
      }
    },
    [t, toast],
  );
}
